/** Configuration of colors, icons and labels for various issue types */
import { BadgeColors } from '../../components/generic/Badge';
import { icons } from '../../components/generic/Icon';
import { getIssueTypeLabel } from '../../helpers/issuesV2';
import type { LicensingIssueType, QualityIssueType } from '../../../shared/issuesV2';
import type { AlertColors, IconClassName, VulnBadgeColors } from '../../components/generic';

export type IssueConfig = {
  title?: string,
  label: string,
  icon?: IconClassName;
  color: BadgeColors | AlertColors | VulnBadgeColors;
};

export const QUALITY_ISSUE_CONFIG: Record<QualityIssueType, IssueConfig> = {
  blacklisted_dependency: {
    label: 'Blocked',
    icon: icons.times,
    color: BadgeColors.Red,
    title: 'Package blocked',
  },
  outdated_dependency: {
    label: 'Outdated',
    icon: icons.clockO,
    color: BadgeColors.DarkGray,
    title: 'Outdated version',
  },
  risk_abandonware: {
    label: 'Risk',
    color: BadgeColors.LightPurple,
    title: 'Abandonware',
  },
  'risk_empty-package': {
    label: 'Risk',
    color: BadgeColors.LightPurple,
    title: 'Empty package',
  },
  'risk_native-code': {
    label: 'Risk',
    color: BadgeColors.LightPurple,
    title: 'Native code',
  },
  malware: {
    label: 'Malware',
    icon: icons.alien8bit,
    color: BadgeColors.DarkRed,
    title: 'Malicious Dependency Identified',
  },
};

/**
 * TODO: moved this to shared/ or helpers, as it's used outside of just the inbox
 */
export const LICENSING_ISSUE_CONFIG: Record<LicensingIssueType, IssueConfig> = {
  policy_conflict: {
    label: getIssueTypeLabel('policy_conflict') as string,
    icon: icons.times,
    color: BadgeColors.Red,
  },
  policy_flag: {
    label: getIssueTypeLabel('policy_flag') as string,
    icon: icons.flag,
    color: BadgeColors.Yellow,
  },
  unlicensed_dependency: {
    label: getIssueTypeLabel('unlicensed_dependency') as string,
    icon: icons.questionCircle,
    color: BadgeColors.DarkGray,
  },
  unconcluded_dependency: {
    label: 'Unconcluded',
    color: BadgeColors.DarkGray,
    title: 'Unconcluded dependency',
    icon: icons.questionCircle,
  },
  multi_license_concluded: {
    label: 'Concluded (Multi)',
    color: BadgeColors.Yellow,
    title: 'Multi License Concluded',
  },
};
